






















































































































































































import Enumerable from "linq";

import { Mixins, Component, Emit, Prop, Watch, Vue } from "vue-property-decorator";
import { EditorItemMixin, CommentReferenceMixin } from "./mixins";
import { FormatReference, WriteMethodTypes, WriteMethodTypeValue } from "../../../../domain/format";
import { User, Profession } from "../../../../domain/user";
import { ReceptionDetail, ReceptionManager, ReceptionProofPeriod, ReceptionComment, ReceptionCommentSet } from "../../../../domain/workflow/reception";
import { WorkflowPhaseEditorModel } from "../../../../domain/workflow/editor";
import {
  ProgressConditionKinds,
  ReceptionEditKinds,
  PhaseStatusKinds,
  FormatStatusKinds,
  ReceptionCommentKinds,
  ReceptionCommentUnitKinds,
} from "../../../../domain/workflow/kinds";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";
import { ReceptionDateTranslator } from "../../../../domain/workflow";
import { DomainRegistry } from "../../../../domain";

import ProjectTeamListSelectorDialog from "../../../projectTeam/dialogs/ProjectTeamListSelectorDialog.vue";
import ReceptionDialogSelector from "../../selectors/ReceptionDialogSelector.vue";
import ProofPeriodDialogSelector from "../../selectors/ProofPeriodDialogSelector.vue";
import ReceptionDetailEditorCommentTabSelector from "../../selectors/ReceptionDetailEditorCommentTabSelector.vue";

import ReceptionDetailDepartmentEditor from "./ReceptionDetailDepartmentEditor.vue";
import ReceptionDetailProjectTeamEditor from "./ReceptionDetailProjectTeamEditor.vue";
import ReceptionDetailDiseaseEditor from "./ReceptionDetailDiseaseEditor.vue";
import ReceptionDetailCommentsEditor from "./ReceptionDetailCommentsEditor.vue";
import WorkflowPhaseEditor from "./WorkflowPhaseEditor.vue";
import HisInfoListSelectDialog from "../../../his/dialogs/HisInfoListSelectDialog.vue";
import { HospitalizationHistorySelectorDialog, VisitHistorySelectorDialog, RoutePatternSelectorDialog } from "../../dialogs";
import { Department } from "../../../../domain/department";
import { IRestriction } from "../../../system";
import { UnmanagedDocumentSummaryInformation } from "../../../../domain/document";
import { IConfiguration } from "../../../../domain/configuration";
import { FormatListSelectorDialog, IFormatListSelectorDialogAddCondition } from "../../../format/dialogs";
import ComboBoxSelector from "../../../system/selectors/ComboBoxSelector.vue";
import ReceptionDetailManagerEditor from "./ReceptionDetailManagerEditor.vue";

@Component({
  components: {
    ReceptionDetailDepartmentEditor,
    ReceptionDetailManagerEditor,
    ReceptionDetailProjectTeamEditor,
    ReceptionDetailDiseaseEditor,
    ReceptionDetailCommentsEditor,
    WorkflowPhaseEditor,
    ReceptionDialogSelector,
    HisInfoListSelectDialog,
    ProofPeriodDialogSelector,
    ReceptionDetailEditorCommentTabSelector,
    ComboBoxSelector,
  }
})
export default class ReceptionDetailEditor extends Mixins(EditorItemMixin, CommentReferenceMixin) {
  // 配列をBindingしているときは、配列の中身の更新は@Modelに相当する仕組みを頑張って実装している
  @Prop()
  mode: ReceptionEditKinds;

  @Prop()
  detail: ReceptionDetail;

  @Prop()
  commonDetail: ReceptionDetail;

  @Prop()
  receptionDate: Date;

  @Prop()
  projectTeamSelectDialog: ProjectTeamListSelectorDialog;

  @Prop()
  hospitalizationHistorySelectDialog: HospitalizationHistorySelectorDialog;

  @Prop()
  visitHistorySelectDialog: VisitHistorySelectorDialog;

  @Prop()
  diseaseSelectDialog: HisInfoListSelectDialog;

  @Prop()
  hospitalizationSelectDialog: HisInfoListSelectDialog;

  @Prop()
  hasSelectableRoutePattern: boolean;

  @Prop()
  routePatternSelectDialog: RoutePatternSelectorDialog;

  @Prop()
  hasDiseaseData: boolean; // 病名情報があるか

  @Prop()
  hasHospitalizationData: boolean; // 入院情報があるか

  @Prop()
  hasHospitalizationHistoryData: boolean;

  @Prop()
  hasVisitHistoryData: boolean;

  @Prop()
  patientSelected: boolean;

  @Prop()
  isHospitalizationHistoryEnable: boolean;

  @Prop()
  isVisitHistoryEnable: boolean;

  @Prop()
  commentLabel: string;

  @Prop()
  isCommentEnable: boolean; // 受付単位入力じゃない

  @Prop()
  hasEditCommentPermission: boolean;

  @Prop()
  restrictCommentLabel: string;

  @Prop()
  isRestrictCommentEnable: boolean;

  @Prop()
  hasEditRestrictCommentPermission: boolean;

  @Prop()
  nextMessageLabel: string;

  @Prop()
  isNextMessageEnable: boolean; // 受付単位入力じゃない

  @Prop()
  hasEditNextMessagePermission: boolean;

  @Prop()
  isProjectTeamEnable: boolean;

  @Prop()
  shouldAutoApplyProjectTeamInfo: boolean;

  @Prop()
  isDepartmentEnable: boolean;

  @Prop()
  isManagerEnable: boolean;

  @Prop()
  isPhaseEnable: boolean;

  @Prop()
  shouldSelectManagers: boolean;

  @Prop()
  detailIndex: number;

  @Prop()
  proofPeriodMaxCount: number;

  @Prop()
  displayProgressConditionKinds: ProgressConditionKinds[];

  @Prop()
  isFormatSelectorAllTabEnable: boolean;

  @Prop()
  isUnmanaged: boolean;

  @Prop()
  unmanagedDocumentSummaryInformations: UnmanagedDocumentSummaryInformation[];

  @Prop()
  isPaperEnable: boolean;

  @Prop()
  isPaperNameEnable: boolean;

  @Prop()
  isPaperCompanyNameEnable: boolean;

  @Prop()
  validateSelectedFormat: (selected?: any) => Promise<boolean>;

  @Prop()
  nonDisplayDepartmentCodes: string[];

  @Prop()
  commonDetailDepartment: Department;

  @Prop()
  allUser: User[];

  @Prop({ default: false })
  isCommentConflicted: boolean;

  @Prop({ default: false })
  isNextMessageConflicted: boolean;

  @Prop({ default: false })
  isRestrictCommentConflicted: boolean;

  @Prop()
  isWorkflowPhasesQuoteEnable: boolean;

  @Prop()
  restrictCommentUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  isCommentRegisterable: boolean;

  @Prop()
  isNextMessageRegisterable: boolean;

  @Prop()
  isRestrictCommentRegisterable: boolean;

  @Prop()
  isCommentEditableSingleUnitOnly: boolean;

  @Prop()
  shouldSortCommentAsc: boolean;

  @Prop()
  paperNameItems: ReceptionTypeItem[];

  @Prop()
  shouldShowManagerPhoneNumber: boolean;

  @Prop()
  isDiseaseVisible: boolean;

  @Emit()
  conflictResolved(kind: ReceptionCommentKinds, confirmedComment: ReceptionComment): void {}

  data(): any {
    return {
      formatOriginalId: null,
      isPaperRoute: false,
      unmanagedDocumentSummaryInformation: null,
      isFormatRoutePatternLoading: false,
      isLoading: false,
      paperNames: [],
    };
  }
  formatOriginalId: number;
  departmentSelector: ReceptionDialogSelector;
  formatSelector: ReceptionDialogSelector;
  proofPeriodSelector: ProofPeriodDialogSelector;
  managerEditor: ReceptionDetailManagerEditor;
  isPaperRoute: boolean;
  unmanagedDocumentSummaryInformation: UnmanagedDocumentSummaryInformation;
  isFormatRoutePatternLoading: boolean;
  isLoading: boolean;

  // 選択肢設定が変更された場合を考慮して算出プロパティにしない
  // this.paperNameが"選択肢にない項目"を選択している状態(依頼登録後に設定変更した場合に起こる)のときに
  // 編集でthis.paperNameを"選択肢にある項目"に変更したとき、元の"選択肢にない項目"に戻せなくなるため
  paperNames: string[];

  @Emit()
  update(detail: ReceptionDetail): void {}

  @Emit()
  remove(): void {}

  @Emit()
  copy(detail: ReceptionDetail): void {}

  @Emit()
  updateCommonDetail(detail: ReceptionDetail): void {}

  created(): void {
    this._dateTranslator = new ReceptionDateTranslator();
  }
  _dateTranslator: ReceptionDateTranslator;

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.departmentSelector = this.$refs.departmentSelector as ReceptionDialogSelector;
    this.formatSelector = this.$refs.formatSelector as ReceptionDialogSelector;
    this.proofPeriodSelector = this.$refs.proofPeriodSelector as ProofPeriodDialogSelector;
    this.managerEditor = this.$refs.managerEditor as ReceptionDetailManagerEditor;

    this.paperNames = this.toPaperNames(this.paperNameItems);
  }

  private setunmanagedDocumentSummaryInformations(): void {
    this.unmanagedDocumentSummaryInformation = Enumerable.from(this.unmanagedDocumentSummaryInformations).firstOrDefault(d => d.documentId === this.detail.sourceDocumentId);
  }

  @Watch("format")
  onFormatUpdated(newValue: FormatReference, oldValue: FormatReference) {
    // フォーマットが変更されていれば
    if (newValue && (!oldValue || newValue.id !== oldValue.id)) {
      // フォーマットが選択状態であれば
      // このタイミングで進捗パターンを取りに行く
      this.getFormatRoutePattern(newValue.id);

      // TODO 紙文書かどうかに応じてチェックボックスの表示制御を行う
    }

    if (newValue !== oldValue) {
      this.setunmanagedDocumentSummaryInformations();
    }
  }

  @Watch("unmanagedDocumentSummaryInformations")
  onunmanagedDocumentSummaryInformations(): void {
    this.setunmanagedDocumentSummaryInformations();
  }

  getFormatRoutePattern(formatOriginalId: number): void {
    this.isFormatRoutePatternLoading = true;
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    repository.getFormatRoutePattern(formatOriginalId)
      .then(r => {
        if (this.isPhaseEnable && !this.shouldKeepPhases) {
          this.phases = r.phases;
        }

        // フォーマット初回選択時にのみ文書共通の進捗に暗影
        if (!this.isPhaseEnable && (!this.commonDetail.route.phases || this.commonDetail.route.phases.length < 1)) {
          const clone = this.commonDetail.clone();
          clone.route.phases = r.phases;
          this.updateCommonDetail(clone);
        }

        this.formatOriginalId = formatOriginalId;
        this.isPaperRoute = this.isPaperEnable && r.isPaper;
        this.isPaper = this.isPaperEnable && r.isPaper;
        this.isFormatRoutePatternLoading = false;
      })
      .catch(e => {
        this.$error("エラー", "進捗パターンの取得に失敗しました。", e);
      });
  }

  ppIndex(index: number): string {
    return this.detailIndex + "-" + index;
  }

  copyDetail(): void {
    if (this.isUnmanagedDocument) {
      this.$warn("文書情報コピーエラー", "#" + (this.detailIndex + 1) + " DocuMaker文書でない文書はコピーできません。");
      return;
    }
    const cloned = this.detail.clone();
    this.copy(cloned);
  }

  get editingDetail(): ReceptionDetail {
    return this.detail;
  }

  set editingDetail(value: ReceptionDetail) {
    this.update(value);
  }

  get isRegistered(): boolean {
    return this.mode === ReceptionEditKinds.Edit && !!this.detail.id;
  }

  get isChangeable(): boolean {
    return !this.isRegistered && !this.detail.quoted;
  }

  // 作成進捗に到達していないか
  get isNotYetDocumentFixPhase(): boolean {
    return !this.isRegistered || this.detail.documentFixPhaseStatus === PhaseStatusKinds.NotYet;
  }

  get isProcessingDocumentFixPhase(): boolean {
    return this.detail.documentFixPhaseStatus === PhaseStatusKinds.Processing;
  }

  // 対応責任者変更可能か
  get isCanChangedManger(): boolean {
    return !this.isRegistered || (this.progressCondition === ProgressConditionKinds.None) || this.isNotYetDocumentFixPhase || this.isProcessingDocumentFixPhase;
  }

  // 証明期間の個数が上限に達しているか
  get isMaxCountProofPeriod(): boolean {
    return this.proofPeriodMaxCount > 0 && this.proofPeriods.length >= this.proofPeriodMaxCount;
  }

  get format(): FormatReference {
    if (!this.detail.format) {
      return null;
    }
    if (this.detail.format.id === null || this.detail.format.id === undefined) {
      return null;
    }
    return this.detail.format;
  }

  set format(value: FormatReference) {
    if (
      value === this.detail.format ||
      (value && this.detail.format && this.detail.format.id === value.id)
    ) {
      // 変更なし
      return;
    }

    const cloned = this.detail.clone();
    cloned.format = value;
    cloned.formatStatus = FormatStatusKinds.Available;
    this.update(cloned);
  }

  selectFormat(): void {
    this.formatSelector.select();
  }

  get isUnmanagedDocument(): boolean {
    return this.isUnmanaged
      && !!this.unmanagedDocumentSummaryInformation
      && !!this.detail.format
      && this.unmanagedDocumentSummaryInformation.isUnmanaged
      && this.detail.format.id === this.unmanagedDocumentSummaryInformation.formatOriginalId;
  }

  get isFormatAvailable(): boolean {
    const formatStatus = this.detail.formatStatus;
    return (formatStatus === undefined || formatStatus === FormatStatusKinds.Available) && !this.isUnmanagedDocument;
  }

  get formatStyles(): any {
    return {
      color: this.isFormatAvailable ? null : this.alertColor,
      backgroundColor: this.isFormatAvailable ? null : this.alertBackgroundColor,
    };
  }

  get alertColor(): string {
    return this.$configuration.style.alertIndication.color;
  }

  get alertBackgroundColor(): string {
    return this.$configuration.style.alertIndication.backgroundColor;
  }

  get isPaper(): boolean {
    return this.detail.isPaper;
  }

  set isPaper(value: boolean) {
    const cloned = this.detail.clone();
    cloned.isPaper = value;
    this.update(cloned);
  }

  get isPaperVisible(): boolean {
    return this.isPaperEnable && !this.isPaperNameEnable && !this.isPaperCompanyNameEnable;
  }

  get isPaperInputVisible(): boolean {
    return this.isPaperEnable && (this.isPaperNameEnable || this.isPaperCompanyNameEnable);
  }

  get paperNameEditable(): boolean {
    return this.isPaperNameEnable && this.isPaper;
  }

  get paperName(): string {
    return this.paperNameEditable ? this.detail.paperName : "";
  }

  set paperName(value: string) {
    const cloned = this.detail.clone();
    cloned.paperName = value;
    this.update(cloned);
  }

  get paperCompanyNameEditable(): boolean {
    return this.isPaperCompanyNameEnable && this.isPaper;
  }

  get paperCompanyName(): string {
    return this.paperCompanyNameEditable ? this.detail.paperCompanyName : "";
  }

  set paperCompanyName(value: string) {
    const cloned = this.detail.clone();
    cloned.paperCompanyName = value;
    this.update(cloned);
  }

  get progressCondition(): ProgressConditionKinds {
    return this.detail.route.progressCondition;
  }

  set progressCondition(value: ProgressConditionKinds) {
    const cloned = this.detail.clone();
    cloned.route.progressCondition = value;
    this.update(cloned);
  }

  get isRoutePatternSelectable(): boolean {
    return !this.isRegistered && this.hasSelectableRoutePattern;
  }

  get isRoutePatternSelectorEnable(): boolean {
    return !!this.format && !this.isFormatRoutePatternLoading;
  }

  get phases(): WorkflowPhaseEditorModel[] {
    return this.detail.route.phases;
  }

  set phases(values: WorkflowPhaseEditorModel[]) {
    const cloned = this.detail.clone();
    cloned.route.phases = values;
    this.update(cloned);
  }

  get isPaperEditable(): boolean {
    return !!this.format && !this.isRegistered && !this.isFormatRoutePatternLoading;
  }
  
  // 子コンポーネント（進捗パターン）からの更新を受信
  updatePhase(index: number, phase: WorkflowPhaseEditorModel) {
    console.log("ReceptionDetailEditor:updatePahse:" + index);
    // console.log(phase);
    const cloned = this.detail.clone();
    cloned.route.phases.splice(index, 1, phase);
    this.update(cloned);
  }

  // 子コンポーネント（進捗パターンの連動選択）,または親コンポーネント（受付日の連動選択）の更新を受信
  updatePhaseDate(index: number, diffDays: number): void {
    if (!this.detail.route.phases) { return; }

    // 受付日の連動選択を契機とする処理の場合は、この直前にbaseDateが更新されている。
    // 進捗に締切日数が指定されているときはbaseDateのWatchを契機として自動計算した締切日をセットする処理があり、
    // 何も対策しない場合は上記の自動計算された締切日により上書きされて、連動した日付とならない。
    // 連動選択の機能としては日付が連動されてほしいため、フラグによるガード処理を追加して対策している
    this.detail.route.phases.forEach((p, i) => {
      const refs = this.$refs.phaseEditor as Vue[];
      if (!refs) { return; }
      const phaseEditor = (refs[i] as WorkflowPhaseEditor);
      if (!phaseEditor) { return; }
      phaseEditor.setLinkedDateUpdating();
    });

    // 連動選択による日付入力を行った進捗以降の締切日を自動で伸ばす
    this.detail.route.phases.forEach((p, i) => {
      if (i < index || !p.limitDate) { return; }
      const limitDate = new Date(p.limitDate);
      limitDate.setDate(limitDate.getDate() + diffDays);
      const refs = this.$refs.phaseEditor as Vue[];
      if (!refs || refs.length < i) { return; }
      (refs[i] as WorkflowPhaseEditor).setLimitDate(limitDate);
    });
  }

  get managers(): User[] {
    // 順番は上から順にする
    return this.detail.managers
      ? Enumerable.from(this.detail.managers)
          .select(m => new User(
            m.staff.id,
            m.staff.name,
            m.staff.profession
              ? new Profession(m.staff.profession.id, m.staff.profession.name, m.staff.profession.category)
              : null,
            m.staff.kanaName,
            m.staff.email,
            m.staff.phone))
          .toArray()
      : [];
  }

  get requiredManagers(): User[] {
    return !!this.detail.documentFixPahseProcessedManagers
      ? this.detail.documentFixPahseProcessedManagers
      : [];
  }

  get selectableHospitalizationHistory(): boolean {
    return this.patientSelected && this.hasHospitalizationHistoryData;
  }

  get hospitalizationHistoryEnable(): boolean {
    return this.isCanChangedManger && this.isHospitalizationHistoryEnable && (this.requiredManagers.length < 1);
  }

  get selectableVisitHistory(): boolean {
    return this.patientSelected && this.hasVisitHistoryData;
  }

  get visitHistoryEnable(): boolean {
    return this.isCanChangedManger && this.isVisitHistoryEnable && (this.requiredManagers.length < 1);
  }

  async launchManagerSelectorAutomatically(): Promise<void> {
    // 対応責任者が変更可能かつ診療科が依頼単位で入力時にのみ有効
    if (this.shouldSelectManagers && this.isCanChangedManger && this.isDepartmentEnable) {
      await this.$nextTick();
      this.selectManagers();
    }
  }

  selectManagers(): void {
    this.managerEditor.selectManagers();
  }

  selectManagerFromHospitalization(): void {
    this.hospitalizationHistorySelectDialog.show().then(h => {
      if (!h) { return; }
      // 追加する場合重複ないようにチェック
      const users = (h.overwriteUser && h.hospitalizationHistory.doctors && h.hospitalizationHistory.doctors.length > 0)
        ? h.hospitalizationHistory.doctors
        : this.toSelectedUsers(...h.hospitalizationHistory.doctors);
      const department = h.hospitalizationHistory.department;

      this.updateDepartmentAndManager(department, users);
    });
  }

  selectManagerFromVisit(): void {
    this.visitHistorySelectDialog.show().then(h => {
      if (!h) { return; }
      // 追加する場合重複ないようにチェック
      const users = (h.overwriteUser && h.visitHisotry.doctor)
        ? new Array(h.visitHisotry.doctor)
        : this.toSelectedUsers(h.visitHisotry.doctor);
      const department = h.visitHisotry.department;

      this.updateDepartmentAndManager(department, users);
    });
  }

  private toSelectedUsers(...doctors: User[]): User[] {
    const addDoctors = Enumerable.from(doctors)
      .where(d => d && !Enumerable.from(this.managers)
      .any(s => s.id === d.id))
      .toArray();
    return (0 < addDoctors.length)
      ? this.toArray(...this.managers).concat(addDoctors)
      : null;
  }

  private toArray<T>(...source: T[]): T[] {
    return source
      ? source.concat() // sourceをそのまま返すと副作用の元なので複製して返す.
      : [];
  }

  async selectRoutePattern(): Promise<void> {
    const route = await this.routePatternSelectDialog.selectOption();
    if (!route) { return; }
    this.phases = route.phases;
  }

  get proofPeriods(): ReceptionProofPeriod[] {
    return this.detail.proofPeriods;
  }

  proofPeriodUpdated(index: number, value: ReceptionProofPeriod): void {
    const cloned = this.detail.clone();
    const newProofPeriod = value.clone(index);
    cloned.proofPeriods.splice(index, 1, newProofPeriod);
    this.update(cloned);
  }

  addProofPeriod(): void {
    if (this.isMaxCountProofPeriod) { return; } // 個数が上限に達していた

    const cloned = this.detail.clone();
    cloned.proofPeriods.splice(this.detail.proofPeriods.length, 0, new ReceptionProofPeriod(this.detail.proofPeriods.length));
    this.update(cloned);
  }

  async showCommentDialogWithCommentTab(source: string, title: string, write: (text: string) => void, label: string, receptionComment: ReceptionComment): Promise<void> {
    this.showCommentDialogWithReferenceComment(source, title, write, this.detail, this.isRegistered);
  }

  updateDepartmentAndManager(department: Department, users: User[]): void {
    if (!department && !users) { return; }
    const detail = this.editingDetail.clone();
    if (department) {
      detail.department = department;  
    }
    if (users) {
      let index: number = 1;
      detail.managers = Enumerable.from(users).select(u => new ReceptionManager(index++, u)).toArray();
    }
    this.editingDetail = detail;
  }

  // TODO フォーマット選択ダイアログ＆フリー文書
  /*
    ISingleSelectableAsynchronously<FormatReference | FreeFormat>を実装したダイアログを作ってDialogSelectorにバインドしてもらえればいいかと。
  上のInterfaceのジェネリクス型に指定してるのが共用体です。
  TypeScriptの共用体はC言語のそれとはだいぶ違って上手く使えば使いやすいと思います。
  TypeScriptの型推論と相まって面白く使える仕様です。
  */
 
  get formatSelectorTabRestrictions(): { [key: string]: IRestriction } {
    return {
      all: {
        isDisabled: !this.isFormatSelectorAllTabEnable,
      },
    };
  }

  get detailDepartment(): Department {
    return this.isDepartmentEnable ? this.detail.department : this.commonDetailDepartment;
  }

  get defaultProfessions(): string[] {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.user.finder.doctorProfessionCodes;
  }

  get formatListSelectorDialog(): FormatListSelectorDialog {
    return this.$commonDialogs.format.listSelector;
  }

  get formatListSelectorDialogCondition(): IFormatListSelectorDialogAddCondition {
    return {
      name: null,
      containsExpired: true,
      containsDeleted: true,
      validate: this.validateSelectedFormat,
      shouldIgnoreChained: false,
      defaultWriteMethodTypes: this.formatListSelectorTargetWriteMethodTypes,
    };
  }

  get formatListSelectorTargetWriteMethodTypes(): WriteMethodTypeValue[] {
      return WriteMethodTypes.WorkflowDefaultTargets;
  }

  get shouldKeepPhases(): boolean {
    return this.isWorkflowPhasesQuoteEnable
      && !!this.detail.sourceReceptionDetailId
      && !this.detail.quoted;
  }

  get phasesDescription(): string {
    return this.shouldKeepPhases
      ? "引用文書なので自動では更新しません。"
      : "";
  }

  get detailId(): number {
    return this.detail
      ? this.detail.id
      : null;
  }

  get commentSet(): ReceptionCommentSet {
    return this.detail
      ? this.detail.commentSet
      : null;
  }

  set commentSet(value: ReceptionCommentSet) {
    if (!this.detail || !this.detail.commentSet) { return; }
    this.detail.commentSet = value;
  }

  get nextMessages(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.nextMessages
      : [];
  }

  get comments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.comments
      : [];
  }

  get restrictComments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.restrictComments
      : [];
  }

  get isMultipleUnitCommentEditTabEnable(): boolean {
    return (this.isMultipleUnitNormalCommentEditable || this.isMultipleUnitRestrictCommentEditable || this.isMultipleUnitNextMessageEditable);
  }

  get isMultipleUnitCommentEditable(): boolean {
    return this.isRegistered && this.isCommentEditableSingleUnitOnly;
  }

  get isMultipleUnitNormalCommentEditable(): boolean {
    return this.isCommentRegisterable && this.isMultipleUnitCommentEditable && this.isMultiple(ReceptionCommentKinds.Comment);
  }

  get isMultipleUnitRestrictCommentEditable(): boolean {
    return this.isRestrictCommentEnable && this.isRestrictCommentRegisterable && this.isMultipleUnitCommentEditable && this.isMultiple(ReceptionCommentKinds.Restrict);
  }

  get isMultipleUnitNextMessageEditable(): boolean {
    return this.isNextMessageRegisterable && this.isMultipleUnitCommentEditable && this.isMultiple(ReceptionCommentKinds.NextMessage);
  }

  toPaperNames(items: ReceptionTypeItem[]): string[] {
    // isDisable=false もしくは編集時に選択されている手書き文書名を表示
    return Enumerable.from(items)
      .where(r => !r.isDisable || (this.paperName && r.name === this.paperName))
      .select(r => r.name)
      .toArray();
  }

  async onCommentUpdated(): Promise<void> {
    await this.updateCommentSet();
  }

  async updateCommentSet(): Promise<void> {
    try {
      this.isLoading = true;
      this.commentSet = await this.getCommentSetByDetailId(this.detailId);
    } finally {
      this.isLoading = false;
    }
  }

  async getCommentSetByDetailId(detailId: number): Promise<ReceptionCommentSet> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.getCommentSet(detailId);
      return result;
    } catch (e) {
      this.$error("コメントセット取得失敗", "コメントセットの取得に失敗しました。", e);
    }
  }

  getUnitKind(commentKind: ReceptionCommentKinds): ReceptionCommentUnitKinds {
    switch (commentKind) {
      case ReceptionCommentKinds.Comment:
        return this.commentUnitKind;
      case ReceptionCommentKinds.NextMessage:
        return this.nextMessageUnitKind;
      case ReceptionCommentKinds.Restrict:
        return this.restrictCommentUnitKind;
      default:
        return null;
    }
  }

  isMultiple(commentKind: ReceptionCommentKinds): boolean {
    return (this.getUnitKind(commentKind) === ReceptionCommentUnitKinds.Multiple);
  }
}
